import { Badge } from "../../primitives/badge";

interface PriorityBadgeProps {
  priority: "urgent" | "recommended" | "consider";
}

export function PriorityBadge({ priority }: PriorityBadgeProps) {
  const config = {
    urgent: {
      label: "Urgent",
      className: "bg-amber-500 text-white border-transparent",
    },
    recommended: {
      label: "Recommended",
      className: "bg-primary/10 text-primary border-primary/20",
    },
    consider: {
      label: "Consider",
      className: "bg-muted text-muted-foreground border-border",
    },
  };

  const { label, className } = config[priority];

  return (
    <Badge variant="outline" className={className}>
      {label}
    </Badge>
  );
}
